import type { UITextKey, UiTextDictionaryId } from "./dictionaries";
import { getUITextDictionary } from "./dictionaries";

export {
  isValidUITextDictionaryId,
  type UITextKey,
} from "./dictionaries";
export {
  UITextProvider,
  type UITextTranslator,
  useUIText,
} from "./UITextProvider";

export const getTranslator = (id: UiTextDictionaryId) => {
  const dictionary = getUITextDictionary(id);
  return {
    t: (key: UITextKey) => {
      return dictionary.texts[key];
    },
  };
};
